<template>
  <div class="generalColumn" :style="styleObject">
    <div v-if="login" class="loadingspinner" style="margin-top: 20%">
      <div id="square1"></div>
      <div id="square2"></div>
      <div id="square3"></div>
      <div id="square4"></div>
      <div id="square5"></div>
    </div>

    <!--    pc端显示-->
    <div v-if="!login" style="margin-top: 8%;width: 65%;height: 50%;justify-content: flex-end;display: flex">

      <div
          style="min-height: 550px;width: 100%;background-color: white;display: flex;flex-direction: column;align-items: center;border-radius: 20px">

        <div style="width: 80%;margin-top: 70px;font-size: 1.6rem;font-weight: bolder">
          统一身份认证
        </div>
        <div style="width: 80%;margin-top: 10px;display: flex">
          <span style="height: 1px;background-color: black;width: 55px;"></span>
        </div>


        <div style="max-height: 280px;">
          <div style="width: 100%;text-align: center;margin-top: 10px">请扫码进入小程序，点击右下角绑定'统一身份认证'按钮，输入账号密码进行绑定</div>
          <div style="display: flex;flex-direction: row">
            <el-image
                style="width: 300px; height: 150px;margin-top: 20px;"
                src="https://moyo-synu-login-v2-prod.cdn.bcebos.com/auto-login-v2/dhd_zhcp/WechatIMG272.jpeg">
              <div slot="error" class="image-slot"
                   style="width: 300px; height: 300px;text-align: center;justify-content: center;align-items: center">
                <div class="spinner" style="margin-top: 100px">
                  <div class="dot1"></div>
                  <div class="dot2"></div>
                </div>
              </div>
            </el-image>


            <el-image
                style="width: 300px; height: 300px;margin-top: 20px;"
                src="https://moyo-synu-login-v2-prod.cdn.bcebos.com/auto-login-v2/dhd_zhcp/%E4%B8%8B%E8%BD%BD.jpeg">
              <div slot="error" class="image-slot"
                   style="width: 300px; height: 300px;text-align: center;justify-content: center;align-items: center">
                <div class="spinner" style="margin-top: 100px">
                  <div class="dot1"></div>
                  <div class="dot2"></div>
                </div>
              </div>
            </el-image>
          </div>

        </div>

      </div>


    </div>


  </div>
</template>

<script>
var timer
// import {isMobile} from "react-device-detect";
import * as clientUtils from "@/axios/ClientUtils";

export default {
  name: "dhd_service",
  data() {
    return {
      login: true,
      styleObject: {
        height: '100vh',
        backgroundImage: '',
        backgroundSize: 'cover'
      },
      ticket:"",
      third_id:""
    }
  },
  methods: {
    getUserInfo() {
      const that = this
      clientUtils.get("autoLogin/v2/pri/user/get/userInfo", function (res) {
        //获取用户信息成功 调用获取应用列表接口getMenu
        if (res.data.code === 0) {
          console.log(res.data.data)
          that.userInfo = res.data.data
          that.$router.replace('AppListPC')
        } else {
          //失败通知及重定向
          that.$notify.error({
            title: '获取用户信息失败',
            message: res.data.msg + res.data.data
          });
          window.location.replace("https://portal.dlou.edu.cn/auth/cas/login?service=https://dhdloginv2.service.timkj.cn/%23/dhd_services");
        }

      })
    },

    getQueryString: function (name) {
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      let r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return decodeURIComponent(r[2]);
      }
      return null;
    },


    //检查绑定状态
    checkCodeState(timer) {
      var myHeaders = new Headers();
      myHeaders.append("app-id", 2)
      var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch("https://loginv2.timkj.cn/autoLogin/v2/pub/auth/getBindThirdState?third_id=" + this.third_id, requestOptions)
          .then(response => response.json())
          .then(function (result) {
            console.log(result.data)
            if (result.data === 0) {
              console.log('未绑定')
            } else if (result.data === 1) {
              console.log("绑定成功")
              clearInterval(timer);
              window.location.replace("https://portal.dlou.edu.cn/auth/cas/login?service=https://dhdloginv2.service.timkj.cn/%23/dhd_services");
            }

          })
          .catch(function (error){
            console.log(error)
            clearInterval(timer)
          });
    },

    loginTicket(){
      let obj = {
        "type": 2,
        "username": "null",
        "password": "",
        "ticket": this.ticket
      }

      const that = this

      var myHeaders = new Headers();
      myHeaders.append("app-id", "2");
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify(obj);

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      };

      fetch("https://loginv2.timkj.cn/autoLogin/v2/pub/auth/login/thirdAuth", requestOptions)
          .then(response => response.json())
          .then(function (res){
            if (res.code === 0) {
              console.log(res)
              let token = res.data
              localStorage.setItem("token", token)
              localStorage.setItem("app_id", 2)
              that.$router.replace('AppListPC')
            } else {
              that.$notify.error({
                title: "自动登录失败",
                message: "该账户未绑定统一身份账号，请按照指引绑定"
              })
              that.login = false
              that.third_id = res.data
              timer =  setInterval(function () {
                that.checkCodeState(timer)
              }, 3000)
            }
          })
          .catch(error => console.log('error', error));
    }

  },
  mounted() {



    this.styleObject.backgroundImage = 'url("https://moyo-synu-login-v2-prod.cdn.bcebos.com/auto-login-v2/assests/dhd/background/web/bg.jpg")'

    let ticket = this.getQueryString("ticket")
    console.log(ticket)

    var appId = localStorage.getItem('app_id')

    let token = localStorage.getItem("token")
    this.ticket = ticket

    if (ticket !== null) {
      this.loginTicket()
    } else {
      //此时token和appId全了，应该获取用户身份信息，调用成功则跳转到appListPc页面
      if (token !== null && parseInt(appId) === 2) {
        console.log("token和appid全了")
        this.getUserInfo()
      } else {
        window.location.replace("https://portal.dlou.edu.cn/auth/cas/login?service=https://dhdloginv2.service.timkj.cn/%23/dhd_services");
      }
    }


  }
}
</script>

<style scoped>
.loadingspinner {
  --square: 26px;
  --offset: 30px;
  --duration: 2.4s;
  --delay: 0.2s;
  --timing-function: ease-in-out;
  --in-duration: 0.4s;
  --in-delay: 0.1s;
  --in-timing-function: ease-out;
  width: calc(3 * var(--offset) + var(--square));
  height: calc(2 * var(--offset) + var(--square));
  padding: 0px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
  margin-bottom: 30px;
  position: relative;
}

.loadingspinner div {
  display: inline-block;
  background: #ff8c00;
  /*background: var(--text-color);*/
  /*box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.4);*/
  border: none;
  border-radius: 2px;
  width: var(--square);
  height: var(--square);
  position: absolute;
  padding: 0px;
  margin: 0px;
  font-size: 6pt;
  color: black;
}

.loadingspinner #square1 {
  left: calc(0 * var(--offset));
  top: calc(0 * var(--offset));
  animation: square1 var(--duration) var(--delay) var(--timing-function) infinite,
  squarefadein var(--in-duration) calc(1 * var(--in-delay)) var(
      --in-timing-function
  ) both;
}

.loadingspinner #square2 {
  left: calc(0 * var(--offset));
  top: calc(1 * var(--offset));
  animation: square2 var(--duration) var(--delay) var(--timing-function) infinite,
  squarefadein var(--in-duration) calc(1 * var(--in-delay)) var(
      --in-timing-function
  ) both;
}

.loadingspinner #square3 {
  left: calc(1 * var(--offset));
  top: calc(1 * var(--offset));
  animation: square3 var(--duration) var(--delay) var(--timing-function) infinite,
  squarefadein var(--in-duration) calc(2 * var(--in-delay)) var(
      --in-timing-function
  ) both;
}

.loadingspinner #square4 {
  left: calc(2 * var(--offset));
  top: calc(1 * var(--offset));
  animation: square4 var(--duration) var(--delay) var(--timing-function) infinite,
  squarefadein var(--in-duration) calc(3 * var(--in-delay)) var(
      --in-timing-function
  ) both;
}

.loadingspinner #square5 {
  left: calc(3 * var(--offset));
  top: calc(1 * var(--offset));
  animation: square5 var(--duration) var(--delay) var(--timing-function) infinite,
  squarefadein var(--in-duration) calc(4 * var(--in-delay)) var(
      --in-timing-function
  ) both;
}

@keyframes square1 {
  0% {
    left: calc(0 * var(--offset));
    top: calc(0 * var(--offset));
  }

  8.333% {
    left: calc(0 * var(--offset));
    top: calc(1 * var(--offset));
  }

  100% {
    left: calc(0 * var(--offset));
    top: calc(1 * var(--offset));
  }
}

@keyframes square2 {
  0% {
    left: calc(0 * var(--offset));
    top: calc(1 * var(--offset));
  }

  8.333% {
    left: calc(0 * var(--offset));
    top: calc(2 * var(--offset));
  }

  16.67% {
    left: calc(1 * var(--offset));
    top: calc(2 * var(--offset));
  }

  25.00% {
    left: calc(1 * var(--offset));
    top: calc(1 * var(--offset));
  }

  83.33% {
    left: calc(1 * var(--offset));
    top: calc(1 * var(--offset));
  }

  91.67% {
    left: calc(1 * var(--offset));
    top: calc(0 * var(--offset));
  }

  100% {
    left: calc(0 * var(--offset));
    top: calc(0 * var(--offset));
  }
}

@keyframes square3 {
  0%,
  100% {
    left: calc(1 * var(--offset));
    top: calc(1 * var(--offset));
  }

  16.67% {
    left: calc(1 * var(--offset));
    top: calc(1 * var(--offset));
  }

  25.00% {
    left: calc(1 * var(--offset));
    top: calc(0 * var(--offset));
  }

  33.33% {
    left: calc(2 * var(--offset));
    top: calc(0 * var(--offset));
  }

  41.67% {
    left: calc(2 * var(--offset));
    top: calc(1 * var(--offset));
  }

  66.67% {
    left: calc(2 * var(--offset));
    top: calc(1 * var(--offset));
  }

  75.00% {
    left: calc(2 * var(--offset));
    top: calc(2 * var(--offset));
  }

  83.33% {
    left: calc(1 * var(--offset));
    top: calc(2 * var(--offset));
  }

  91.67% {
    left: calc(1 * var(--offset));
    top: calc(1 * var(--offset));
  }
}

@keyframes square4 {
  0% {
    left: calc(2 * var(--offset));
    top: calc(1 * var(--offset));
  }

  33.33% {
    left: calc(2 * var(--offset));
    top: calc(1 * var(--offset));
  }

  41.67% {
    left: calc(2 * var(--offset));
    top: calc(2 * var(--offset));
  }

  50.00% {
    left: calc(3 * var(--offset));
    top: calc(2 * var(--offset));
  }

  58.33% {
    left: calc(3 * var(--offset));
    top: calc(1 * var(--offset));
  }

  100% {
    left: calc(3 * var(--offset));
    top: calc(1 * var(--offset));
  }
}

@keyframes square5 {
  0% {
    left: calc(3 * var(--offset));
    top: calc(1 * var(--offset));
  }

  50.00% {
    left: calc(3 * var(--offset));
    top: calc(1 * var(--offset));
  }

  58.33% {
    left: calc(3 * var(--offset));
    top: calc(0 * var(--offset));
  }

  66.67% {
    left: calc(2 * var(--offset));
    top: calc(0 * var(--offset));
  }

  75.00% {
    left: calc(2 * var(--offset));
    top: calc(1 * var(--offset));
  }

  100% {
    left: calc(2 * var(--offset));
    top: calc(1 * var(--offset));
  }
}

@keyframes squarefadein {
  0% {
    transform: scale(0.75);
    opacity: 0;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.generalColumn {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
}
</style>